/* Empty, loading and error states per screen - "not yet specified" in the
 * deck's own build notes (Product Screens slide 29). Designed once here so
 * every table and detail screen shares one vocabulary instead of
 * improvising a message per screen.
 */
import type { ReactNode } from "react";
import s from "./EmptyState.module.css";

export function EmptyState({ title, detail, action }: { title: string; detail?: ReactNode; action?: ReactNode }) {
  return (
    <div className={s["empty-state"]}>
      <p className={s["empty-state__title"]}>{title}</p>
      {detail && <p className={s["empty-state__detail"]}>{detail}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ detail, onRetry }: { detail?: string; onRetry?: () => void }) {
  return (
    <div className={`${s["empty-state"]} ${s["empty-state--error"]}`}>
      <p className={s["empty-state__title"]}>Something went wrong</p>
      {detail && <p className={s["empty-state__detail"]}>{detail}</p>}
      {onRetry && (
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function Skeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className={s["skeleton"]} aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={s["skeleton__row"]} />
      ))}
    </div>
  );
}
